// extracted by mini-css-extract-plugin
module.exports = {"wukPagination":"style_wukPagination__TRlQP"};